<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPLOAD" }} SITE THEME</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
          <!-- <label for=""> Upload File</label> -->
         <!-- <vs-input type="file" ref="file"  label="Upload Zip File" class="w-full" accept=".zip,.rar,.7zip" @change="updateZip"></vs-input> -->
          <input class="ml-10 mt-10 mb-6 hidden" type="file" ref="file" @change="updateZip" accept=".zip,">
          <vs-button class="mr-4 ml-4 mt-10 mb-6" @click.native="$refs.file.click()">Upload File</vs-button>
          <ul v-if="uploded">
            <li v-for="file in uploded">
              {{file}}
            </li>
          </ul>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <!-- <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button> -->
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { UPLOAD_SITE_THEME } from "@/graphql";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      dataId:null,
      dataName:null,
      uploded:null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id,name} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataName = name
        this.uploded=null
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName  
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    updateZip(input){
        var file = this.$refs.file.files[0]
        console.log(file)
        this.$apollo
        .mutate({
          mutation: UPLOAD_SITE_THEME,
          variables: {
            file: file,
            site: this.dataName
          }
        })
        .then(response => {
        console.log(response.data.uploadSiteTheme)
        this.uploded=response.data.uploadSiteTheme
        this.$vs.notify({
        color: "success",
        title: "Theme",
        position: 'top-right',
        text: "Upload Successully"
      })
                    
        this.$refs.file[0].value = null
        }).catch(error => {
  
        })
    },
    alertNofity (color,text) {
      this.$vs.notify({
        color: color,
        title: "Page",
        position: 'top-right',
        text: text
      })
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            
          } else {

            
         


          }


        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
